import store from '@/store'

export const mixin = {
  methods: {
    snackbar ({ message = '', type = 'default', time = 3000 }) {
      store.dispatch('snackbar/setSnackbar', { message, type, time})
    },
    spinner (val) {
      store.dispatch('spinner/setSpinner', val)
    },
    logoutspinner (val) {
      store.dispatch('logoutspinner/setSpinner', val)
    },
  }
}